module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0072.jpg?v=dc563ab4";